/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumModelPagedResultSchema } from "../albumModelPagedResultSchema.ts";
import { albumTypeEnumSchema } from "../albumTypeEnumSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAlbumsQueryParamsSchema = z.object({
    "AuthorIds": z.array(z.string().uuid()).describe("Фильтр по авторам (хотя бы один из переданных авторов является автором альбома)").optional(),
"CollectionId": z.string().uuid().describe("Фильтр по выпуску (альбом входит в выпуск)").optional(),
"NotAnyCollection": z.boolean().describe("Фильтр: альбом не принадлежит выпускам").optional(),
"ExcludeCollectionId": z.string().uuid().describe("Фильтр по выпуску (альбом не входит в выпуск)").optional(),
"AlbumIds": z.array(z.string().uuid()).describe("Фильтр по идентификаторам").optional(),
"Types": z.array(z.lazy(() => albumTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный альбом</li>\n<li><b>2 - Podcast</b>: Альбом подкастов</li>\n<li><b>3 - Book</b>: Альбом книг</li>\n<li><b>4 - Sermon</b>: Альбом проповедей</li>\n</ul>\n")).describe("Фильтр по типу альбома").optional(),
"SortByName": z.boolean().describe("Сортировка по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по наименованию с конца").optional(),
"SortByAuthor": z.boolean().describe("Сортировка по основному автору").optional(),
"SortByAuthorDesc": z.boolean().describe("Сортировка по основному автору с конца").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список альбомов
 */
export const getApiAlbums200Schema = z.lazy(() => albumModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAlbums400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAlbums401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAlbums403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAlbums500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAlbumsQueryResponseSchema = z.lazy(() => getApiAlbums200Schema)